export default {
  read: (value: string) => JSON.parse(value),
  write: (value: any[]) => JSON.stringify(value),
}
